import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {AangifteRapport} from '@snelstart-ventures/fiscaal/domain-logic';
import {FormControl, FormGroup} from '@angular/forms';
import {SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {CommonModule} from '@angular/common';
import {BehaviorSubject} from "rxjs";
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {SharedUiDialogModule} from "@snelstart/ui-dialog";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-zorgkosten',
  templateUrl: './spec-zorgkosten.component.html',
  styleUrls: ['./spec-zorgkosten.component.scss'],
  imports: [SharedUiFormControlsModule, SharedUiDetailsModule, CommonModule, SharedUiButtonModule, SharedUiDialogModule],
})
export class SpecZorgkostenComponent implements OnChanges {

  @Input() public id!: string;
  @Input({required: true}) public rapport!: AangifteRapport;
  public dataVisible$ = new BehaviorSubject<boolean>(false);
  public dialogVisible = false;

  public formGroup = new FormGroup({
    behandelKosten: new FormControl<number | null>(0),
    medicijnKosten: new FormControl<number | null>(0),
    hulpmiddelen: new FormControl<number | null>(0),
    extraGezinshulp: new FormControl<number | null>(0),
    drempelExtraGezinshulp: new FormControl<number | null>(0),
    aftrekbaarExtraGezinshulp: new FormControl<number | null>(0),
    reiskostenEigenZorg: new FormControl<number | null>(0),
    reiskostenGezinslid: new FormControl<number | null>(0),
    kledingEnBeddengoed: new FormControl<number | null>(0),
    dieetkosten: new FormControl<number | null>(0),
    totaalZorgkostenVoorVerhoging: new FormControl<number | null>(0),
    grondslagVerhoging: new FormControl<number | null>(0),
    verhogingZorgkosten: new FormControl<number | null>(0),
    zorgkostenVoorDrempel: new FormControl<number | null>(0),
    drempelZorgkosten: new FormControl<number | null>(0),
    aftrekbareZorgkosten: new FormControl<number | null>(0),
    aandeelZorgkosten: new FormControl<number | null>(0),
  });

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['rapport'] && this.rapport) {
      this.dataVisible$.next(false);
      this.formGroup.reset({} , {emitEvent: false});
      this.formGroup.patchValue(this.rapport.specificatieZorgkosten?.opbouw || {}, {emitEvent: false});
      this.formGroup.disable();
      this.dataVisible$.next(true);
    }
  }

  showDialog() {
    this.dialogVisible = true;
  }
}
